import { CampaignPrize } from '../../../types/prizes';

const getPrizeType = (prize: CampaignPrize): CampaignPrize['__type'] => {
  switch (true) {
    case prize.at_least:
      return 'at_least';
    case prize.top:
      return 'top';
    case prize.at_least_units:
      return 'at_least_units';
    case prize.top_units:
      return 'top_units';
    default:
      return undefined;
  }
};

const addPrizeType = <T extends CampaignPrize>(CampaignPrize: T): T => {
  const type = getPrizeType(CampaignPrize);
  return { ...CampaignPrize, __type: type };
};
export { addPrizeType };
